<div #section id="reports" class="agpr-userPreferences-subSection">
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ "UserPreferences.reports" | localize }}
    </h4>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            id="report.userPreferences.reports.filters"
            [items]="reports"
            [initialValues]="reportPreferences.defaultFilters"
            [defaultFilters]="defaultReportsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{ "Report.userPreferences.defaultColors" | localize }}
        </h5>
        <div class="agpr-reportPreferences-colors">
            <agpr-panel
                [header]="'Report.userPreferences.defaultColors.general'"
                [headingLevel]="5"
                [id]="id + '.reportPreference.colors.general'"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div
                        class="agpr-reportPreferences-colors-group agpr-reportPreferences-colors-group-general"
                    >
                        <div class="agpr-reportPreferences-colors-color">
                            <div *ngFor="let color of keys(generalColorsLeft)">
                                <agpr-color-picker-field
                                    class="agpr-reportPreferences-colors-input"
                                    [id]="'-reportPreference-ColorPicker' + color"
                                    [field]="generalColorsLeft[color].field"
                                    [value]="generalColorsLeft[color].value"
                                    (changes)="
                                        generalColorsLeft[color].updateValue(
                                            $event
                                        );
                                        updateDirtyFlag()
                                    "
                                ></agpr-color-picker-field>
                            </div>
                        </div>
                        <div class="agpr-reportPreferences-colors-color">
                            <div *ngFor="let color of keys(generalColorsRight)">
                                <agpr-color-picker-field
                                    class="agpr-reportPreferences-colors-input"
                                    [id]="'-reportPreference-ColorPicker' + color"
                                    [field]="generalColorsRight[color].field"
                                    [value]="generalColorsRight[color].value"
                                    (changes)="
                                        generalColorsRight[color].updateValue(
                                            $event
                                        );
                                        updateDirtyFlag()
                                    "
                                ></agpr-color-picker-field>
                            </div>
                        </div>
                    </div>
                </div>
            </agpr-panel>
            <agpr-panel
                [id]="id + '.reportPreference.colors.media'"
                [header]="'Report.userPreferences.defaultColors.media'"
                [headerIcon]="'fa-regular fa-circle-info'"
                [headerIconTooltip]="
                    'Report.userPreferences.defaultColors.media.tooltip'
                "
                [iconAfter]="true"
                [headingLevel]="5"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div class="agpr-reportPreferences-colors-group">
                        <div class="agpr-reportPreferences-colors-color">
                            <div
                                *ngFor="let color of keys(mediaTypeColorsLeft)"
                            >
                                <agpr-color-picker-field
                                    class="agpr-reportPreferences-colors-input"
                                    [id]="'-reportPreference-ColorPicker' + color"
                                    [field]="mediaTypeColorsLeft[color].field"
                                    [value]="mediaTypeColorsLeft[color].value"
                                    (changes)="
                                        mediaTypeColorsLeft[color].updateValue(
                                            $event
                                        );
                                        updateDirtyFlag()
                                    "
                                ></agpr-color-picker-field>
                            </div>
                        </div>
                        <div class="agpr-reportPreferences-colors-color">
                            <div
                                *ngFor="let color of keys(mediaTypeColorsRight)"
                            >
                                <agpr-color-picker-field
                                    class="agpr-reportPreferences-colors-input"
                                    [id]="'-reportPreference-ColorPicker' + color"
                                    [field]="mediaTypeColorsRight[color].field"
                                    [value]="mediaTypeColorsRight[color].value"
                                    (changes)="
                                        mediaTypeColorsRight[color].updateValue(
                                            $event
                                        );
                                        updateDirtyFlag()
                                    "
                                ></agpr-color-picker-field>
                            </div>
                        </div>
                    </div>
                </div>
            </agpr-panel>
            <agpr-panel
                [id]="id + '.reportPreference.colors.socialMedia'"
                [header]="'Report.userPreferences.socialMedia.colors'"
                [headerIcon]="'fa-regular fa-circle-info'"
                [headerIconTooltip]="
                    'Report.userPreferences.defaultColors.media.tooltip'
                "
                [iconAfter]="true"
                [headingLevel]="5"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div class="agpr-reportPreferences-colors-group">
                        <div
                            class="agpr-reportPreferences-colors-color"
                            *ngFor="let color of keys(socialMediaColors)"
                        >
                            <agpr-color-picker-field
                                class="agpr-reportPreferences-colors-input"
                                [id]="'-reportPreference-ColorPicker' + color"
                                [field]="socialMediaColors[color].field"
                                [value]="socialMediaColors[color].value"
                                (changes)="
                                    socialMediaColors[color].updateValue(
                                        $event
                                    );
                                    updateDirtyFlag()
                                "
                            ></agpr-color-picker-field>
                        </div>
                    </div>
                </div>
            </agpr-panel>
            <agpr-panel
                [id]="id + '.reportPreference.colors.otherMedia'"
                [header]="'Report.userPreferences.otherMedia.colors'"
                [headerIcon]="'fa-regular fa-circle-info'"
                [headerIconTooltip]="
                    'Report.userPreferences.defaultColors.media.tooltip'
                "
                [iconAfter]="true"
                [collapsed]="true"
                [headingLevel]="5"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div class="agpr-reportPreferences-colors-group">
                        <div
                            class="agpr-reportPreferences-colors-color"
                            *ngFor="let color of keys(otherMediaColors)"
                        >
                            <agpr-color-picker-field
                                class="agpr-reportPreferences-colors-input"
                                [id]="'-reportPreference-ColorPicker' + color"
                                [field]="otherMediaColors[color].field"
                                [value]="otherMediaColors[color].value"
                                (changes)="
                                    otherMediaColors[color].updateValue($event);
                                    updateDirtyFlag()
                                "
                            ></agpr-color-picker-field>
                        </div>
                    </div>
                </div>
            </agpr-panel>
            <agpr-panel
                [id]="id + '.reportPreference.colors.sentiment'"
                [header]="'Report.userPreferences.defaultColors.sentiment'"
                [headerIcon]="'fa-regular fa-circle-info'"
                [headerIconTooltip]="
                    'Report.userPreferences.defaultColors.sentiment.tooltip'
                "
                [iconAfter]="true"
                [headingLevel]="5"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div class="agpr-reportPreferences-colors-group">
                        <div
                            class="agpr-reportPreferences-colors-color"
                            *ngFor="
                                let color of keys(chartColors.sentimentColors)
                            "
                        >
                            <agpr-color-picker-field
                                class="agpr-reportPreferences-colors-input"
                                [id]="'-reportPreference-ColorPicker' + color"
                                [field]="chartColors.sentimentColors[color].field"
                                [value]="chartColors.sentimentColors[color].value"
                                (changes)="
                                     chartColors.sentimentColors[
                                        color
                                    ].updateValue($event);
                                    updateDirtyFlag()
                                "
                            ></agpr-color-picker-field>

                        </div>
                    </div>
                </div>
            </agpr-panel>
            <agpr-panel
                [id]="id + '.reportPreference.colors.bar'"
                [header]="'Report.userPreferences.defaultColors.bar'"
                [headerIcon]="'fa-regular fa-circle-info'"
                [headerIconTooltip]="
                    'Report.userPreferences.defaultColors.bar.tooltip'
                "
                [iconAfter]="true"
                [headingLevel]="5"
            >
                <div class="agpr-reportPreferences-colors-category">
                    <div class="agpr-reportPreferences-colors-group">
                        <div
                            class="agpr-reportPreferences-colors-color"
                            *ngFor="let color of keys(chartColors.barColors)"
                        >
                            <agpr-color-picker-field
                                class="agpr-reportPreferences-colors-input"
                                [id]="'-reportPreference-ColorPicker' + color"
                                [field]="chartColors.barColors[color].field"
                                [value]="chartColors.barColors[color].value"
                                (changes)="
                                 chartColors.barColors[color].updateValue(
                                        $event
                                    );
                                    updateDirtyFlag()
                                "
                            ></agpr-color-picker-field>
                        </div>
                    </div>
                </div>
            </agpr-panel>
        </div>
    </div>
</div>
